import type { ReactNode } from "react";
import { textBlocks } from "@/lib/posting";
import PostingBlocks from "./PostingBlocks";
import { GroupLabel, SectionCard } from "./parts";

/**
 * The posting's own text, in its headings, paragraphs, lists and labels, and its pay and place,
 * then `foot` under a rule: what to do once it is read, so a long posting does not send the
 * reader back up for it.
 */
export default function PostingText({
    description,
    payAndPlace,
    foot,
}: {
    description: string;
    payAndPlace?: string | null;
    foot?: ReactNode;
}) {
    const blocks = textBlocks(description);
    return (
        <SectionCard className="gap-4" title="The Posting">
            <div className="flex max-w-[68ch] flex-col gap-3 text-read [text-wrap:pretty] [&>[data-field]+[data-field]]:-mt-2">
                {blocks.length === 0 ? (
                    <p className="m-0 text-fg-muted">The posting gives no text.</p>
                ) : (
                    <PostingBlocks
                        blocks={blocks}
                        Heading="h3"
                        headingClassName="m-0 mt-3 -mb-1 font-display text-subhead font-semibold text-fg first:mt-0"
                    />
                )}
                {payAndPlace && (
                    <>
                        <span className="mt-1">
                            <GroupLabel>Pay and place</GroupLabel>
                        </span>
                        <p className="m-0">{payAndPlace}</p>
                    </>
                )}
            </div>
            {foot && <div className="flex flex-wrap gap-2 border-t border-line pt-4">{foot}</div>}
        </SectionCard>
    );
}
